<template>
  <div class="main-content">
    <div class="conetnt-top">
      <div class="content-top-title">
        <span class="top-title">NGS平台芯片</span>
      </div>
      <div class="content-top-form">
        <el-form
          :inline="true"
          :model="searchForm"
          :rules="searchFormRules"
          ref="ruleForm"
          label-width="120px"
          size="medium"
        >
          <el-form-item prop="date" label="选择时段">
            <el-date-picker
              v-model="formExtraData.date"
              type="daterange"
              range-separator="至"
              start-placeholder="上传文件开始日期"
              end-placeholder="上传文件时间结束日期"
              value-format="yyyy-MM-dd"
              @change="onChangeDate"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item prop="chipType" label="芯片种类">
            <el-select
              v-model="searchForm.chipType"
              placeholder="请选择芯片种类"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in formExtraData.chipTypeList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="chipCode" label="芯片识别号">
            <el-input
              v-model="searchForm.chipCode"
              clearable
              placeholder="请输入芯片识别号"
              maxlength="200"
            ></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" size="small" @click="handleSearch"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <div>
          该时段共计{{ formExtraData.days || 0 }}个自然日，共上机{{
            formExtraData.sumCount || 0
          }}次，流转订单{{
            formExtraData.sumOrderCount || 0
          }}个，平均芯片使用率{{
            formExtraData.avgChipUseRate || 0
          }}%，芯片理论成本共计{{ formExtraData.sumChipTheoryCost || 0 }}
          万元。（外送上机芯片使用率不参与统计）
        </div>
      </div>
    </div>
    <div class="content-middle" style="padding-top: 10px; padding-bottom: 10px">
      <div class="middle-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          ref="tableRef"
          :header-cell-style="{ background: '#F5F7FA', color: '#5C6474' }"
        >
          <el-table-column label="芯片种类" prop="chipType" align="center" />
          <el-table-column label="芯片识别号" prop="chipCode" align="center" />
          <el-table-column
            label="芯片最大通量(G)"
            prop="chipMaxFlux"
            align="center"
          />
          <el-table-column
            label="芯片实际上机通量(G)"
            prop="chipRealFlux"
            align="center"
          />
          <el-table-column label="样本例数" prop="sampleNum" align="center" />
          <el-table-column label="订单量" prop="orderNum" align="center" />
          <el-table-column
            label="芯片使用率"
            prop="chipUseRatio"
            align="center"
          >
            <template slot-scope="scope">
              {{
                getTimesNumber(scope.row.chipUseRatio)
                  ? getTimesNumber(scope.row.chipUseRatio) + "%"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="芯片实际成本(万)"
            prop="chipRealCost"
            align="center"
          />
          <el-table-column
            label="芯片理论成本(万)"
            prop="chipTheoryCost"
            align="center"
          />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="onDetail(scope.row)"
                >查看明细</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="middle-pagination">
          <el-pagination
            :current-page="searchForm.pageNum"
            :page-sizes="searchForm.sizes"
            :page-size="searchForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchForm.total"
            @current-change="onChangePageNum"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { customerPermissions, getNowFormatDate } from "@/utils";
import Big from "big.js";
export default {
  name: "Company",
  data() {
    let validateDate = (rule, value, callback) => {
      console.log("formExtraData", this.formExtraData);
      if (!this.formExtraData.date) {
        callback(new Error("请先选择时段"));
      } else {
        callback();
      }
    };
    return {
      searchFormRules: {
        date: [{ validator: validateDate, required: true, trigger: "change" }],
      },
      tableData: [],
      formExtraData: {
        date: [],
        chipTypeList: [],
        labList: [],
        avgChipUseRate: 0,
        days: 0,
        sumChipTheoryCost: 0,
        sumCount: 0,
        sumOrderCount: 0,
      },
      searchForm: {
        beginDate: "",
        chipCode: "",
        chipType: "",
        endDate: "",
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.getWeekDate();
    this.getList();
    this.getSummary();
    this.getChipTypeList();
  },
  methods: {
    getWeekDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
      var tMonth = new Date().getMonth() + 1;
      // console.log("月份", tMonth);
      this.formExtraData.date = [start, end];
      this.onChangeDate([start, end]);
    },
    getChipTypeList() {
      this.axios.get("getChipType", "").then((result) => {
        this.formExtraData.chipTypeList = result.data;
      });
    },
    onChangeDate(val) {
      if (!val) {
        this.searchForm.beginDate = "";
        this.searchForm.endDate = "";
      } else {
        this.searchForm.beginDate = val[0];
        this.searchForm.endDate = val[1];
      }
    },
    onDetail(row) {
      this.$router.push(`/labAnalyze/NGSChip/detail/${row.id}`);
    },
    getTimesNumber(num) {
      if (num === null || num === undefined || num === "") {
        return "";
      }
      let x = new Big(num);
      return x.times(100);
    },
    handleSearch() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.searchForm.pageNum = 1;
          this.getSummary();
          this.getList();
        }
      });
    },
    onChangePageNum(pageNum) {
      this.searchForm.pageNum = pageNum;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.getList();
    },
    getList() {
      this.axios.post("getChipInfoByPage", this.searchForm).then((result) => {
        console.log("result", result);
        this.tableData = result.data.records;
        this.searchForm.total = result.data.total;
      });
    },
    getSummary() {
      this.axios.post("getChipSummary", this.searchForm).then((result) => {
        console.log("result", result);
        const {
          avgChipUseRate,
          days,
          sumChipTheoryCost,
          sumCount,
          sumOrderCount,
        } = result.data;
        this.formExtraData = Object.assign({}, this.formExtraData, {
          avgChipUseRate,
          days,
          sumChipTheoryCost,
          sumCount,
          sumOrderCount,
        });
      });
    },
  },
};
</script>
<style scoped>
.conetnt-top {
  border-radius: 8px;
  background: #ffffff;
  padding: 12px 24px;
}

.content-top-title {
  padding-bottom: 19px;
}

.top-title {
  font-weight: 500;
  color: #303133;
  font-size: 18px;
  padding-right: 13px;
}

.top-desc {
  color: #606266;
  font-size: 14px;
}

.el-icon-question {
  color: #c0c4cc;
}

.top-form {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.form-item {
  width: 25%;
  padding: 0 12px;
  padding-left: 0;
  margin-bottom: 12px;
}

.form-item-components {
  width: 100%;
}

.form-item-components >>> .require-icon:before {
  content: "*";
  color: #f56c6c;
  margin-left: 10px;
  padding-top: 3px;
  height: 100%;
  display: block;
}

.search-btns {
  width: 100%;
  padding-right: 12px;
  text-align: right;
}

.content-middle {
  padding: 24px;
  margin-top: 24px;
  background: #ffffff;
  box-shadow: 0px 4px 32px 0px rgba(64, 98, 117, 0.12);
  border-radius: 8px;
}

.middle-data {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.middle-data-item {
  width: 24%;
  padding: 24px;
  border-radius: 8px;
}

.middle-data-item:nth-child(1) {
  background: #c6e6f5;
}

.middle-data-item:nth-child(2) {
  background: #c6e6f5;
}

.middle-data-item:nth-child(3) {
  background: #cbedea;
}

.middle-data-item:nth-child(4) {
  background: #f3d9ee;
}
.item-title {
  font-size: 14px;
  font-weight: 400;
  color: #606266;
}
.item-number {
  padding-top: 16px;
  font-size: 28px;
  font-weight: 500;
  color: #303133;
}

.middle-table {
  padding-top: 23px;
  width: 100%;
}

.middle-pagination {
  padding-top: 10px;
  text-align: right;
}
</style>
